import { OVField, OVForm, OVSidebar, OVTable, OVSearchable, OVEntity, OVSearch } from '@ov-suite/ov-metadata';

@OVEntity('Printer')
@OVForm([['#Printer Details'], ['name', 'ipAddress'], ['port', ''], ['description']])
@OVSidebar([['id']])
@OVTable<Printer>([
  {
    key: 'name',
    title: 'Name',
    type: 'string',
  },
  {
    key: 'ipAddress',
    title: 'IP Address',
    type: 'string',
  },
  {
    key: 'port',
    title: 'Port',
    type: 'number',
  },
])
@OVSearch<Printer>({ searchKeys: ['name', 'ipAddress'] })
export class Printer {
  @OVField({
    type: 'string',
    title: 'ID',
    sidebar: true,
    generated: true,
    readonly: true,
  })
  id: number;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Printer Name',
    placeholder: 'Required',
    required: true,
  })
  name: string;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'IP Address',
    placeholder: 'Required (e.g., 192.168.1.100)',
    required: true,
  })
  ipAddress: string;

  @OVField({
    type: 'number',
    title: 'Port',
    placeholder: 'Default: 9100',
    required: false,
    min: 1,
    max: 65535,
  })
  port = 9100;

  @OVField({
    type: 'string',
    title: 'Description',
    required: false,
  })
  description?: string;
}
